// based on https://github.com/uidotdev/usehooks/blob/main/index.js#L1300
import { useSyncExternalStore } from 'react';

const useVisibilityChangeSubscribe = (callback: any) => {
  document.addEventListener('visibilitychange', callback);

  return () => {
    document.removeEventListener('visibilitychange', callback);
  };
};

const getVisibilityChangeSnapshot = () => {
  return document.visibilityState;
};

const getVisibilityChangeServerSnapshot = () => {
  throw Error('useVisibilityChange is a client-only hook');
};

export function useVisibilityChange() {
  const visibilityState = useSyncExternalStore(
    useVisibilityChangeSubscribe,
    getVisibilityChangeSnapshot,
    getVisibilityChangeServerSnapshot,
  );

  return visibilityState === 'visible';
}
